module.exports = __webpack_public_path__ + "static/media/gorra (14).a6917ee4.png";